module.exports = __webpack_public_path__ + "static/media/fly0051.c5b7c45d.webp";